import {httpNewApi} from '~/composables/useVzFetch';
import {OrderWrappingType} from '~/types/types';
import {IWrappingPostData, Wrapping} from '~/types/api';
import {useMemoize} from '@vueuse/core';

export const getOrderWrappingTypesByLocation = useMemoize(
  async (locationGuid: string) => {
    const res = await $fetch(
      `${httpApiV3}/order/wrapping/state`,
      {params: {locationGuid}, credentials: 'include'}
    ) as OrderWrappingType[]
    // Костыль, чтоб постановка на паллет была скрыта всегда (мешается в шаблонах, а так поставить при 250кг можно)
    if (!locationGuid) {
      const palletCustomer = res.find(wrapping => wrapping.code === 'palletCustomer')
      if (palletCustomer) {
        palletCustomer.disabled = true
      }
    }
    return res
  })

export const getOrderWrappingTypes = useMemoize((): Promise<OrderWrappingType[]> => {
  return $fetch(`${httpApiV3}/order/wrapping`, {credentials: 'include'})
})

export const getWrappers = (body: IWrappingPostData): Promise<Wrapping[]> => {
  return useVzFetch(`${httpNewApi}/order/wrapping/get-list`, {
    method: 'POST',
    body: Object.assign(body, {grouped: false})
  })

}
